<template>
  <div class="store-selection">
    <v-card
      max-width="400"
      min-width="400"
      class="mx-auto">
      <v-card-title>Connect with Lazada Shop</v-card-title>
      <v-card-text>
        <div><strong>Code : </strong> {{ code }}</div>
      </v-card-text>
      <v-card-text>
        <v-select
          v-model="store"
          :items="storeOptions"
          item-text="name"
          label="Store"
          color="secondary"
          outlined
          dense
          :menu-props="{ offsetY: true }"
          return-object
          @change="onStoreChange"
        />

        <v-select
          v-model="brand"
          :items="filteredBrands"
          item-text="name"
          item-value="name"
          label="Brand"
          color="secondary"
          outlined
          dense
          :menu-props="{ offsetY: true }"
          :disabled="!store"
        />

        <v-btn
          color="secondary"
          block
          :loading="loading"
          :disabled="code === '' || store === null || brand === null"
          @click="submit">
          Connect
        </v-btn>
        <div
          v-if="code === ''"
          class="error-text text-center mt-2">
          The code is missing.
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import LazadaProvider from '@/resources/LazadaProvider'

const LazadaService = new LazadaProvider()

export default {
  data () {
    return {
      store: null,
      brand: null,
      loading: false,
      info: {
        code: ''
      },
      storeOptions: [
        {
          id: '5e3548c2d32cb12606a34fb8',
          name: 'Gentlewoman'
        },
        {
          id: '645a1d00765d5519beeb97f6',
          name: 'Matter Makers'
        }
      ],
      brandOptions: [
        {
          name: 'Sandbox',
          store: {
            id: '5e3548c2d32cb12606a34fb8',
            name: 'gentlewoman'
          },
          uniqueCode: 'SB',
          id: 5
        },
        {
          name: 'Gentlewoman',
          store: {
            id: '5e3548c2d32cb12606a34fb8',
            name: 'gentlewoman'
          },
          uniqueCode: 'GW',
          id: 1
        },
        {
          name: 'Gentlelittlewoman',
          store: {
            id: '5e3548c2d32cb12606a34fb8',
            name: 'gentlewoman'
          },
          uniqueCode: 'LW',
          id: 2
        },
        {
          store: {
            id: '645a1d00765d5519beeb97f6',
            name: 'Matter Makers'
          },
          name: 'Matter Makers',
          uniqueCode: 'MM',
          id: 3
        },
        {
          name: 'Gentlewoman Universe',
          uniqueCode: 'GU',
          store: {
            id: '5e3548c2d32cb12606a34fb8',
            name: 'gentlewoman'
          },
          id: 4
        }
      ]
    }
  },
  computed: {
    filteredBrands () {
      if (!this.store) return []
      return this.brandOptions.filter((brand) => brand.store.id === this.store.id)
    },
    code () {
      return this.$route.query.code
    }
  },
  mounted () {
    if (!this.code) {
      this.$store.dispatch('Components/setSnackbar', {
        value: true,
        message: 'Error: Code not found',
        type: 'error'
      })
    }
  },
  methods: {
    onStoreChange () {
      this.brand = ''
    },
    async submit () {
      const payload = {
        code: this.code,
        store: this.store,
        brand: this.brand
      }

      try {
        this.loading = true
        const { data } = await LazadaService.connectShop(payload)
        if (data) {
          this.$store.dispatch('Components/setSnackbar', {
            value: true,
            message: 'Connected',
            type: 'success'
          })
          this.$router.push({ name: 'Home' })
        }
      } catch (error) {
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: `Error: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.store-selection {
  padding: 20px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  min-height: 100dvh;
}
.error-text {
  color: red;
  font-size: 14px;
}
</style>
